import converge from "./converge";
import merge from "./merge";
import omit from "./omit";
import prop from "./prop";

const liftKey = (key) => converge(merge, [omit([key]), prop(key)]);

export default liftKey;
